import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Coupons } from 'src/app/_models/coupons.model';
import { CouponsService } from 'src/app/_services/coupons.service';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { environment } from 'src/environments/environment';
import { doctorSpecilaities } from 'src/app/_models/specialities.model';
import { DoctorSpecilaitiesService } from 'src/app/_services/doctor-specilaities.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-coupon',
  templateUrl: './add-coupon.component.html',
  styleUrls: ['./add-coupon.component.scss'],
})
export class AddCouponComponent implements OnInit {
  pageTitle: string = 'Coupons';
  editMode = false;
  coupon: Coupons = {};
  specialities: any = [];
  specialitiesIds: any = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'item_text',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    enableCheckAll: false,
  };
  addCouponForm: FormGroup;
  isSubmited: boolean = false;
  fromMinDate: Date;
  toMinDate: Date;

  constructor(
    private adminCouponsService: CouponsService,
    private docsSpecialitiesService: DoctorSpecilaitiesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public toastr: ToastrService,
    private _formBuilder: FormBuilder
  ) {
    this.fromMinDate = new Date();
    this.toMinDate = new Date();
    this.fromMinDate.setDate(this.fromMinDate.getDate());
    this.toMinDate.setDate(this.toMinDate.getDate() + 1);
  }

  ngOnInit(): void {
    this.addCouponForm = this._formBuilder.group({
      couponName: [null, [Validators.required]],
      couponType: [null, [Validators.required]],
      couponClassification: [null, [Validators.required]],
      couponStartDate: [null, [Validators.required]],
      couponEndDate: [null, [Validators.required]],
      couponDiscountPercentage: [null, [Validators.required]],
      couponAmount: [null, [Validators.required]],
      couponSpecialties: [null],
    });

    this.editMode =
      this.activatedRoute.snapshot.url[1] &&
      this.activatedRoute.snapshot.url[1].path === 'edit' &&
      true;

    if (this.editMode) {
      const id = this.activatedRoute.snapshot.params.couponId;
      this.getCouponById(id);
    } else {
      this.getAllSpecialities();
    }
  }

  getCouponById(CouponId) {
    this.adminCouponsService.getCouponById(CouponId).subscribe((res) => {
      this.coupon = res.data;
      this.coupon.startDate = new Date(res.data.startDate);
      this.coupon.endDate = new Date(res.data.endDate);

      this.addCouponForm.patchValue({
        couponName: this.coupon.couponName,
        couponType: this.coupon.couponType,
        couponClassification: this.coupon.couponNameType,
        couponStartDate: this.coupon.startDate,
        couponEndDate: this.coupon.endDate,
        couponDiscountPercentage: this.coupon.discountPercentage,
        couponAmount: this.coupon.amount,
      });

      this.getAllSpecialities();
    });
  }

  generateSelectedSpecialitiesList(stringIds) {
    if (stringIds) {
      let selectedSpecialities = stringIds
        .split(',')
        .join('')
        .split(' ')
        .join('');

      let isnum = /^\d+$/.test(selectedSpecialities);

      if (isnum) {
        let selectedSpecialitiesNumberArray = [
          ...new Set(stringIds.split(',').map(Number)),
        ];
        let selectedSpecialitiesObjectArray = this.specialities.filter(
          (speciality) => {
            return (
              selectedSpecialitiesNumberArray.indexOf(speciality.id) !== -1
            );
          }
        );

        this.addCouponForm.controls['couponSpecialties'].setValue(
          selectedSpecialitiesObjectArray
        );
      } else {
        this.addCouponForm.controls['couponSpecialties'].setValue(null);
      }
    }
  }

  getAllSpecialities() {
    this.docsSpecialitiesService.getAllSpecialities().subscribe((res) => {
      this.specialities = res?.data?.doctorSpecilaities.map((spec) => {
        return {
          id: spec.id,
          item_text: spec.name,
        };
      });

      if (this.editMode) {
        this.generateSelectedSpecialitiesList(this.coupon.couponClass);
      }
    });
  }

  onDiscountChange(e) {
    if (this.addCouponForm.value.couponDiscountPercentage > 0) {
      this.addCouponForm.controls['couponAmount'].setValue(0);

      if (this.addCouponForm.value.couponDiscountPercentage > 100) {
        this.addCouponForm.controls['couponDiscountPercentage'].setValue(100);
      }
    }
  }

  onAmountChange(e) {
    if (this.addCouponForm.value.couponAmount > 0) {
      this.addCouponForm.controls['couponDiscountPercentage'].setValue(0);
    }
  }

  generateCopounObject(couponFormValue) {
    if (couponFormValue.couponName.replace(/\s/g, '').length) {
      this.coupon.couponName = couponFormValue.couponName;
    } else {
      this.addCouponForm.controls['couponName'].setValue(null);
    }

    this.coupon.couponType = couponFormValue.couponType;
    this.coupon.couponNameType = couponFormValue.couponClassification;
    this.coupon.startDate = couponFormValue.couponStartDate;

    if (couponFormValue.couponEndDate <= this.coupon.startDate) {
      const startDate = new Date(this.coupon.startDate);
      this.coupon.endDate = new Date(
        startDate.setDate(startDate.getDate() + 1)
      );
    } else {
      this.coupon.endDate = couponFormValue.couponEndDate;
    }

    this.coupon.discountPercentage = couponFormValue.couponDiscountPercentage;
    this.coupon.amount = couponFormValue.couponAmount;

    if (couponFormValue.couponSpecialties?.length) {
      couponFormValue.couponSpecialties.forEach((speciality) => {
        this.specialitiesIds.push(speciality.id);
      });

      this.coupon.couponClass = this.specialitiesIds.join(',');
    }
  }

  onAddCouponSubmit() {
    this.isSubmited = true;

    this.generateCopounObject(this.addCouponForm.value);

    if (this.addCouponForm.valid) {
      if (this.editMode) {
        this.adminCouponsService.updateCoupon(this.coupon).subscribe((res) => {
          showNotification(
            'success',
            `${res.data.couponName} has been added`,
            this.toastr
          );
          this.router.navigateByUrl('coupons');
        });
      } else {
        this.adminCouponsService.addNewCoupon(this.coupon).subscribe((res) => {
          showNotification(
            'success',
            `${res.data.couponName} has been added`,
            this.toastr
          );
          this.router.navigateByUrl('coupons');
        });
      }
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }
}
